/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Consent_TermsInputs */

const en_signup_consent_terms = /** @type {(inputs: Signup_Consent_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I am at least 18 and accept the [Terms of Service](/terms), including the [Data Processing Agreement](/dpa). I have read the [Privacy Policy](/privacy).`)
};

const pl_signup_consent_terms = /** @type {(inputs: Signup_Consent_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mam co najmniej 18 lat i akceptuję [Regulamin](/terms), w tym [Umowę powierzenia przetwarzania danych](/dpa). Znam treść [Polityki prywatności](/privacy).`)
};

/**
* | output |
* | --- |
* | "I am at least 18 and accept the [Terms of Service](/terms), including the [Data Processing Agreement](/dpa). I have read the [Privacy Policy](/privacy)." |
*
* @param {Signup_Consent_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const signup_consent_terms = /** @type {((inputs?: Signup_Consent_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Consent_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_signup_consent_terms(inputs)
	return en_signup_consent_terms(inputs)
});